import { FC } from 'react';
import { type Quiz } from '@teachur/http-client';
import { Progress } from '@new/common/ui/Progress/Progress';

interface ExamQuestionsHeaderProps {
  quiz: Quiz;
  currentQuestionIndex: number;
}

export const ExamQuestionsHeader: FC<ExamQuestionsHeaderProps> = ({
  quiz,
  currentQuestionIndex,
}) => {
  const totalQuestions = quiz.assessments?.length ?? 0;
  const currentQuestionNumber = currentQuestionIndex + 1;
  const progressPercent = totalQuestions > 0 ? (currentQuestionNumber / totalQuestions) * 100 : 0;

  return (
    <div className="flex flex-col gap-3">
      <div className="flex items-center justify-between">
        <h3 className="[font-family:var(--font-arvo)] [font-size:var(--fs-h5)]! lg:[font-size:var(--fs-h4)]! text-(--neutral-black-NB1000)! m-0! font-semibold!">
          Course Exam
        </h3>
      </div>
      <div className="h-px bg-(--neutral-white-NW800)" />

      <div className="flex flex-col py-5 gap-2.5">
        <div className="flex items-center justify-between">
          <p className="[font-size:var(--fs-p4)]! text-(--neutral-black-NB400) font-medium m-0!">
            Your Progress
          </p>
          <p className="[font-size:var(--fs-p4)]! lg:[font-size:var(--fs-p3)]! text-(--neutral-black-NB700) m-0! font-medium text-right">
            Question {String(currentQuestionNumber).padStart(1, '0')} of{' '}
            {String(totalQuestions).padStart(2, '0')}
          </p>
        </div>
        <Progress value={progressPercent} className="w-full h-3 lg:h-4.75" />
      </div>
    </div>
  );
};
